import namespace from './namespace';
import {effect} from 'utils/redux';
import {setPageTitleMessage} from 'io/app';
import {getQuery} from 'io/history';
import * as globalActions from 'modules/common/actions';
import services from 'services';
import {loggedIn} from 'modules/common/selectors';
import {normalizeLoginRedirect} from 'utils/url';

const creator = effect(namespace);

// `callbackPath` is the path to the azure callback. In this app it is always `window.location.pathname`, so we are matching these exactly in our router. See App.js for reference.
export let initialize = callbackPath => async (getState, dispatch) => {
	setPageTitleMessage('Uudelleen ohjataan')(getState, dispatch);

	if (loggedIn(getState())) {
		localStorage.removeItem('redirectUrl');
		window.location.assign('/');
		return;
	}

	const token = getQuery().code;

	const api = await services.waitFor('api');

	try {
		const {token: apiToken} = await api.httpJson('get', `${callbackPath}?code=${token}`);
		dispatch(globalActions.afterLogin(apiToken));
	} catch (e) {
		const resMsg = await e.response.json().then(res => res.info);
		const redirectUrl = new URL(
			normalizeLoginRedirect(localStorage.getItem('redirectUrl')) ?? '/',
			window.location.href,
		);
		redirectUrl.searchParams.set('error', resMsg);
		// decodeQuery uses decodeURIComponent, which expects %20 rather than + for spaces.
		redirectUrl.search = redirectUrl.search.replace(/\+/g, '%20');
		localStorage.removeItem('redirectUrl');
		window.location.assign(normalizeLoginRedirect(redirectUrl.href));
		throw e;
	}
};
initialize = creator('initialize', initialize);
